import { defineMessages } from 'react-intl';

export default defineMessages({
  price: 'KLAP Price',
  yourBalance: 'Your Balance',
  buyKlap: 'Buy KLAP',
  tradeNow: 'Trade Now!',
  tradeOnGate: 'Trade on Gate!',
});
